var staticDecodeURIComponent = decodeURIComponent

module.exports = staticDecodeURIComponent



//////////////////
// WEBPACK FOOTER
// ./node_modules/_xe-utils@3.5.7@xe-utils/staticDecodeURIComponent.js
// module id = 167
// module chunks = 0 1 2 3 4